import LoginView from '@/sections/login/login-view'

export default function Login() {
  return <LoginView />
}
